import { render, staticRenderFns } from "./version-edit-form.vue?vue&type=template&id=6d2edcf6"
import script from "./version-edit-form.vue?vue&type=script&lang=js"
export * from "./version-edit-form.vue?vue&type=script&lang=js"
import style0 from "./version-edit-form.vue?vue&type=style&index=0&id=6d2edcf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports